'use client';

import { useQueries } from '@tanstack/react-query';
import {
  TICKETING_PROVIDERS,
  type TicketingProviderType,
} from '@terra/shared-contracts-knowledge-sync';
import { ticketingIntegrationsApi } from '../../clients/tester-client/ticketing-integrations-api';
import { useFeatureFlags } from '../useFeatureFlags';

export const TICKETING_CONNECTION_STATUS_QUERY_KEY =
  'ticketing-connection-status';

const ALWAYS_ENABLED_TICKETING_PROVIDERS: TicketingProviderType[] = [
  TICKETING_PROVIDERS.LINEAR,
  TICKETING_PROVIDERS.JIRA,
  TICKETING_PROVIDERS.SERVICENOW,
];

const HEALTHY_CONNECTION_STATUS = 'VALID';

export function useTicketingIntegrationConnected() {
  const { isFeatureFlagEnabled: isNativeGithubIssuesEnabled } = useFeatureFlags(
    'NATIVE_GITHUB_ISSUES_ENABLED',
  );
  const providers = isNativeGithubIssuesEnabled
    ? [...ALWAYS_ENABLED_TICKETING_PROVIDERS, TICKETING_PROVIDERS.GITHUB_ISSUES]
    : ALWAYS_ENABLED_TICKETING_PROVIDERS;

  return useQueries({
    queries: providers.map((provider) => ({
      queryKey: [TICKETING_CONNECTION_STATUS_QUERY_KEY, provider],
      queryFn: () =>
        ticketingIntegrationsApi.getTicketingConnectionStatus(provider),
      refetchOnWindowFocus: false,
    })),
    combine: (results) => ({
      hasTicketingIntegrationConnected: results.some(
        (result) => result.data?.status === HEALTHY_CONNECTION_STATUS,
      ),
      isLoading: results.some((result) => result.isLoading),
    }),
  });
}
